import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-6 space-y-4" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_3 = {
  key: 0,
  class: "p-4 bg-green-50 rounded-lg shadow-sm ring-1 ring-green-200"
}
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-5 gap-4" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "text-sm text-green-700" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "text-sm text-green-700 group-hover:text-green-900 group-hover:underline" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "text-sm text-green-700 group-hover:text-green-900 group-hover:underline" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "text-sm text-green-700" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = { class: "text-sm text-green-700" }
const _hoisted_15 = {
  key: 1,
  class: "p-4 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800"
}
const _hoisted_16 = {
  key: 2,
  class: "p-4 bg-white rounded-lg shadow-sm border border-gray-200"
}
const _hoisted_17 = { class: "space-y-3" }
const _hoisted_18 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2" }
const _hoisted_19 = { class: "font-semibold text-sm text-gray-900" }
const _hoisted_20 = { class: "text-xs font-medium text-gray-700" }
const _hoisted_21 = { class: "mt-2 grid grid-cols-1 sm:grid-cols-3 gap-2 text-xs" }
const _hoisted_22 = { class: "text-gray-600" }
const _hoisted_23 = { class: "text-gray-600" }
const _hoisted_24 = { class: "mt-3 flex flex-col sm:flex-row gap-2" }
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { class: "sm:w-[24rem] grid grid-cols-2 gap-2" }
const _hoisted_27 = ["onClick", "disabled"]
const _hoisted_28 = ["onClick", "disabled"]
const _hoisted_29 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_30 = { class: "grid grid-cols-2 md:grid-cols-4 gap-3" }
const _hoisted_31 = { class: "p-3 bg-white rounded-lg border border-gray-200" }
const _hoisted_32 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_33 = { class: "p-3 bg-white rounded-lg border border-gray-200" }
const _hoisted_34 = { class: "text-lg font-semibold text-green-700" }
const _hoisted_35 = { class: "p-3 bg-white rounded-lg border border-gray-200" }
const _hoisted_36 = { class: "text-lg font-semibold text-red-700" }
const _hoisted_37 = { class: "p-3 bg-white rounded-lg border border-gray-200" }
const _hoisted_38 = { class: "text-lg font-semibold text-indigo-700" }
const _hoisted_39 = { class: "bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_40 = { class: "flex overflow-x-auto border-b border-gray-200" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "h-6 w-px bg-gray-300 self-center"
}
const _hoisted_43 = {
  key: 0,
  class: "text-gray-500 text-sm py-4 text-center"
}
const _hoisted_44 = {
  key: 0,
  class: "text-gray-500 text-sm py-6 text-center"
}
const _hoisted_45 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_46 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_47 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_48 = { class: "px-4 py-2 text-sm text-gray-700 whitespace-nowrap" }
const _hoisted_49 = { class: "px-4 py-2 text-sm text-gray-700 whitespace-nowrap" }
const _hoisted_50 = { class: "px-4 py-2 text-sm text-gray-700" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "mt-4 flex justify-end" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "mb-4" }
const _hoisted_55 = { class: "text-gray-700 mb-2" }
const _hoisted_56 = { class: "font-medium" }
const _hoisted_57 = { class: "mt-4 flex justify-end space-x-3" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "mb-4" }
const _hoisted_60 = { class: "text-gray-700 mb-2" }
const _hoisted_61 = { class: "font-medium" }
const _hoisted_62 = { class: "mt-4 flex justify-end space-x-3" }
const _hoisted_63 = ["disabled"]

import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useTasksStore } from '@/stores/v2';
import { storeToRefs } from 'pinia';
import { useFishImport } from "@/composables/tasks/fish-import/useFishImport";
import { useTaskHistory } from "@/composables/tasks/useTaskHistory";
import { useNotifications } from "@/composables/useNotifications";
import { normalizeRouteParam } from "@/utils/v2/routes";
import TaskHeader from '@/components/v2/Tasks/Task/TaskHeader.vue';
import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import FooterActions from "@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue";
import JustificationModal from "@/components/v2/Modal/JustificationModal.vue";

type FishImportView = "imports" | "overview";

interface Props {
  viewMode?: FishImportView;
}

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    viewMode: {}
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const router = useRouter();
const taskKey = normalizeRouteParam(route.params.key as string | string[]);
const { activeTask } = storeToRefs(useTasksStore());
const { recordChange, requireJustification } = useTaskHistory();
const { showSuccess, showError, showWarning } = useNotifications();

const {
  importData,
  transfers,
  selectedTransfer,
  selectedTransferIndex,
  selectTransfer,
  globalImportAmount,
  recordTransferAmount,
  recordTransferRemoval,
  addDiscrepancyOnTask,
  totalActualAmount,
  totalTargetAmount,
  totalAddedAmount,
  totalRemovedAmount,
  selectedTransferBreakdown,
  selectedTransferProgressEntries,
  handleCompleteTask,
  getTransferActualAmount,
  getEventTypeLabel,
  getOperationLabel,
  formatTimestamp,
  importLogModal,
  toggleImportLogModal,
} = useFishImport();

const currentView = computed<FishImportView>(() => props.viewMode || "imports");
const isImportsView = computed(() => currentView.value === "imports");
const isOverviewView = computed(() => currentView.value === "overview");
const hasSelectedTransfer = computed(() => !!selectedTransfer.value);

const getTransferLabel = (transferIndex: number): string => {
  const transfer = transfers.value[transferIndex];
  if (!transfer) return "Unknown tank";
  return `${transfer.tank.label} (${transfer.tank.room})`;
};

const pageTitle = computed(() => {
  if (isImportsView.value) return "Import Fish";
  return "Import Overview";
});
const pageDescription = computed(() => {
  if (isImportsView.value) return "Record imported fish per tank and remove fish when needed with justification.";
  return "Review all import and removal events before finishing the task.";
});
const hasTransfers = computed(() => transfers.value.length > 0);

const importDraftAmounts = ref<Record<string, number | null>>({});

const getRemainingToTarget = (transferTarget: number, importedAmount: number): number => {
  return transferTarget - importedAmount;
};

const recordImportForTransfer = (transferIndex: number, transferKey: string) => {
  const amount = Number(importDraftAmounts.value[transferKey] || 0);

  if (!Number.isFinite(amount) || amount <= 0) {
    showWarning("Invalid Amount", "Please enter an import amount greater than 0.");
    return;
  }

  selectTransfer(transferIndex);
  globalImportAmount.value = amount;
  recordTransferAmount();
  importDraftAmounts.value[transferKey] = null;
};

const recordRemovalForTransfer = async (transferIndex: number, transferKey: string) => {
  const amount = Number(importDraftAmounts.value[transferKey] || 0);

  if (!Number.isFinite(amount) || amount <= 0) {
    showWarning("Invalid Amount", "Please enter a removal amount greater than 0.");
    return;
  }

  const transfer = transfers.value[transferIndex];
  if (!transfer) {
    showError("Tank Not Found", "Unable to find selected tank for removal.");
    return;
  }

  const normalizedAmount = Math.abs(amount);
  const currentAmount = getTransferActualAmount(transfer);
  const newAmount = currentAmount - normalizedAmount;

  if (normalizedAmount > currentAmount) {
    showWarning(
      "Insufficient Imported Fish",
      `Cannot remove ${normalizedAmount} fish from ${getTransferLabel(transferIndex)} because only ${currentAmount} are available.`
    );
    return;
  }

  try {
    const justification = await requireJustification({
      fieldPath: `imports.transfers.${transfer.key}.progressData`,
      fieldName: `Fish removal (${getTransferLabel(transferIndex)})`,
      oldValue: currentAmount,
      newValue: newAmount,
      justification: "",
    });

    const trimmedJustification = justification.trim();
    if (!trimmedJustification) return;

    const historySaved = await recordChange({
      fieldPath: `imports.transfers.${transfer.key}.progressData`,
      fieldName: `Fish removal (${getTransferLabel(transferIndex)})`,
      oldValue: currentAmount,
      newValue: newAmount,
      context: "FishImport",
      contextType: "remove",
      workflowStage: "import",
      requireJustification: false,
      justification: trimmedJustification,
    });

    if (!historySaved) {
      showError("Removal Failed", "Failed to store removal justification history.");
      return;
    }

    selectTransfer(transferIndex);
    const saved = recordTransferRemoval(normalizedAmount, "other_adjustment", trimmedJustification);
    if (!saved) return;

    importDraftAmounts.value[transferKey] = null;
    showSuccess("Removal Recorded", `${normalizedAmount} fish removed from ${getTransferLabel(transferIndex)}.`);
  } catch (error) {
    // User cancelled the justification modal.
  }
};

const goToImports = () => {
  router.push({ name: "FishImportImports", params: { key: taskKey } });
};

const goToOverview = () => {
  router.push({ name: "FishImportOverview", params: { key: taskKey } });
};

// New batch ID editing state
const showBatchIdModal = ref(false);
const newBatchId = ref('');

// Weight (size) editing state
const showWeightModal = ref(false);
const newWeight = ref('');

// Show batch ID edit modal
const startEditBatchId = () => {
  newBatchId.value = importData.value?.batchId ?? "";
  showBatchIdModal.value = true;
};

// Show weight edit modal
const startEditWeight = () => {
  newWeight.value = importData.value?.size ?? "";
  showWeightModal.value = true;
};

// Close batch ID edit modal
const closeBatchIdModal = () => {
  showBatchIdModal.value = false;
};

// Close weight edit modal
const closeWeightModal = () => {
  showWeightModal.value = false;
};

// Handle save batch ID with justification
const saveBatchId = async () => {
  if (newBatchId.value) {
    const oldValue = importData.value?.batchId ?? "";

    try {
      const success = await recordChange({
        fieldPath: 'importData.batchId',
        fieldName: 'Batch ID',
        oldValue,
        newValue: newBatchId.value,
        context: 'FishImport',
        contextType: 'edit',
        workflowStage: 'import',
        requireJustification: true,
        justification: ''
      });

      if (success && importData.value) {
        importData.value.batchId = newBatchId.value;
        showSuccess("Batch ID Updated", "Batch ID has been successfully updated.");
        closeBatchIdModal();
      }
    } catch (error) {
      console.error('Error updating batch ID:', error);
      showError("Update Failed", "Failed to update batch ID. Please try again.");
    }
  }
};

// Handle save weight with justification
const saveWeight = async () => {
  if (newWeight.value) {
    const oldValue = importData.value?.size ?? "";

    try {
      const success = await recordChange({
        fieldPath: 'importData.size',
        fieldName: 'Weight',
        oldValue,
        newValue: newWeight.value,
        context: 'FishImport',
        contextType: 'edit',
        workflowStage: 'import',
        requireJustification: true,
        justification: ''
      });

      if (success && importData.value) {
        importData.value.size = newWeight.value;
        showSuccess("Weight Updated", "Weight has been successfully updated.");
        closeWeightModal();
      }
    } catch (error) {
      console.error('Error updating weight:', error);
      showError("Update Failed", "Failed to update weight. Please try again.");
    }
  }
};

// Comment for the import log modal
const comment = ref('');

// Handle submit when user adds a comment for discrepancy
const handleSubmitComment = () => {
  if (comment.value) {
    try {
      const saved = addDiscrepancyOnTask(comment.value);
      if (saved) {
        comment.value = '';
        toggleImportLogModal();
        handleCompleteTask();
      }
    } catch (error) {
      console.error('Error submitting comment:', error);
      showError("Submission Failed", "Failed to submit comment. Please try again.");
    }
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(activeTask))
      ? (_openBlock(), _createBlock(TaskHeader, {
          key: 0,
          title: _unref(activeTask).title,
          study: _unref(activeTask).studyTitle
        }, null, 8, ["title", "study"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (isImportsView.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_unref(importData))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-md font-semibold text-green-900 mb-3" }, "Import details", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-xs font-semibold text-green-800 uppercase" }, "Vendor", -1)),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(importData).vendor), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-xs font-semibold text-green-800 uppercase" }, "Batch ID", -1)),
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer group",
                        onClick: startEditBatchId
                      }, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(importData).batchId), 1),
                        _cache[6] || (_cache[6] = _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "h-4 w-4 ml-1 text-green-600",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                          })
                        ], -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-xs font-semibold text-green-800 uppercase" }, "Weight", -1)),
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer group",
                        onClick: startEditWeight
                      }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(importData).size), 1),
                        _cache[8] || (_cache[8] = _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "h-4 w-4 ml-1 text-green-600",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                          })
                        ], -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-xs font-semibold text-green-800 uppercase" }, "Size Tolerance", -1)),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(importData).sizeTolerance ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-xs font-semibold text-green-800 uppercase" }, "Species", -1)),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(importData).species), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!hasTransfers.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No tanks are configured for this import task. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "text-md font-semibold text-gray-900 mb-1" }, "Import by tank", -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-sm text-gray-600 mb-3" }, "Record fish directly on each tank to avoid switching contexts.", -1)),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transfers), (transfer, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: transfer.key,
                        class: "p-3 rounded-lg border border-gray-200"
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("p", _hoisted_19, _toDisplayString(transfer.tank.label) + " (" + _toDisplayString(transfer.tank.room) + ")", 1),
                          _createElementVNode("p", _hoisted_20, " Imported " + _toDisplayString(_unref(getTransferActualAmount)(transfer)) + " / " + _toDisplayString(transfer.targetAmount), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("p", _hoisted_22, "Target: " + _toDisplayString(transfer.targetAmount), 1),
                          _createElementVNode("p", _hoisted_23, "Imported: " + _toDisplayString(_unref(getTransferActualAmount)(transfer)), 1),
                          _createElementVNode("p", {
                            class: _normalizeClass(getRemainingToTarget(transfer.targetAmount, _unref(getTransferActualAmount)(transfer)) < 0 ? 'text-red-700 font-medium' : 'text-gray-600')
                          }, " Remaining: " + _toDisplayString(getRemainingToTarget(transfer.targetAmount, _unref(getTransferActualAmount)(transfer))), 3)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((importDraftAmounts.value[transfer.key]) = $event),
                            min: "1",
                            class: "border border-gray-300 text-center text-base w-full p-2 rounded",
                            placeholder: "Amount"
                          }, null, 8, _hoisted_25), [
                            [
                              _vModelText,
                              importDraftAmounts.value[transfer.key],
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (recordImportForTransfer(index, transfer.key)),
                              class: "text-sm rounded bg-primary px-4 py-2 text-white border border-white",
                              disabled: Number(importDraftAmounts.value[transfer.key] || 0) <= 0
                            }, " Add to tank ", 8, _hoisted_27),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (recordRemovalForTransfer(index, transfer.key)),
                              class: "text-sm rounded bg-rose-700 px-4 py-2 text-white border border-white",
                              disabled: Number(importDraftAmounts.value[transfer.key] || 0) <= 0 || _unref(getTransferActualAmount)(transfer) <= 0
                            }, " Remove from tank ", 8, _hoisted_28)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs text-gray-500 uppercase" }, "Target", -1)),
                _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(totalTargetAmount)), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-xs text-gray-500 uppercase" }, "Added", -1)),
                _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(totalAddedAmount)), 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-xs text-gray-500 uppercase" }, "Removed", -1)),
                _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(totalRemovedAmount)), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-xs text-gray-500 uppercase" }, "Net Imported", -1)),
                _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(totalActualAmount)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transfers), (transfer, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: transfer.key
                  }, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_unref(selectTransfer)(index)),
                      class: _normalizeClass(["px-4 py-2 text-sm font-medium whitespace-nowrap", _unref(selectedTransferIndex) === index
                ? 'text-primary border-b-2 border-primary'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'])
                    }, _toDisplayString(transfer.tank.label) + " (" + _toDisplayString(transfer.tank.room) + ") ", 11, _hoisted_41),
                    (index < _unref(transfers).length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              (!hasSelectedTransfer.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, " No tank selected. "))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_unref(selectedTransferProgressEntries).length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, " No activity recorded for this tank. "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("table", _hoisted_46, [
                            _cache[19] || (_cache[19] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Time"),
                                _createElementVNode("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Event "),
                                _createElementVNode("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Change "),
                                _createElementVNode("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Comment ")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", _hoisted_47, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedTransferProgressEntries), (entry) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: entry.key
                                }, [
                                  _createElementVNode("td", _hoisted_48, _toDisplayString(_unref(formatTimestamp)(entry.timestamp)), 1),
                                  _createElementVNode("td", _hoisted_49, _toDisplayString(_unref(getEventTypeLabel)(entry.eventType)) + " (" + _toDisplayString(_unref(getOperationLabel)(entry.operation)) + ") ", 1),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["px-4 py-2 text-sm font-semibold whitespace-nowrap", entry.delta >= 0 ? 'text-green-700' : 'text-red-700'])
                                  }, _toDisplayString(entry.delta > 0 ? '+' : '') + _toDisplayString(entry.delta), 3),
                                  _createElementVNode("td", _hoisted_50, _toDisplayString(entry.comment || '-'), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                  ], 64))
            ])
          ])),
      _createVNode(FooterActions, null, {
        start: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isImportsView.value ? null : goToImports())),
            disabled: isImportsView.value,
            class: _normalizeClass([{ 'opacity-60 cursor-not-allowed': isImportsView.value }, "w-full"])
          }, " Import ", 10, _hoisted_51)
        ]),
        end: _withCtx(() => [
          (isOverviewView.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleCompleteTask) && _unref(handleCompleteTask)(...args))),
                class: "w-full"
              }, " Finish task "))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: goToOverview,
                class: "w-full"
              }, " Overview "))
        ]),
        _: 1
      })
    ]),
    (_unref(importLogModal))
      ? (_openBlock(), _createBlock(ModalBox, {
          key: 1,
          onClose: _unref(toggleImportLogModal),
          width: "lg"
        }, {
          header: _withCtx(() => _cache[20] || (_cache[20] = [
            _createElementVNode("h3", { class: "text-lg font-medium text-gray-900" }, " Import Log ", -1)
          ])),
          main: _withCtx(() => [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mb-4" }, [
              _createElementVNode("p", { class: "text-gray-700" }, " The number of fish you imported doesn't match the expected amount. Please provide an explanation. This will be saved as an explicit discrepancy adjustment event: ")
            ], -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((comment).value = $event)),
              class: "w-full p-2 border border-gray-300 rounded-md",
              rows: "4",
              placeholder: "Enter your explanation here..."
            }, null, 512), [
              [_vModelText, comment.value]
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("button", {
                onClick: handleSubmitComment,
                class: "bg-primary text-white px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed",
                disabled: !comment.value
              }, " Submit and Complete ", 8, _hoisted_53)
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (showBatchIdModal.value)
      ? (_openBlock(), _createBlock(ModalBox, {
          key: 2,
          onClose: closeBatchIdModal,
          width: "md"
        }, {
          header: _withCtx(() => _cache[22] || (_cache[22] = [
            _createElementVNode("h3", { class: "text-lg font-medium text-gray-900" }, " Edit Batch ID ", -1)
          ])),
          main: _withCtx(() => [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("p", _hoisted_55, [
                _cache[23] || (_cache[23] = _createTextVNode(" Current Batch ID: ")),
                _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(importData)?.batchId), 1)
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("label", {
                for: "newBatchId",
                class: "block text-sm font-medium text-gray-700"
              }, "New Batch ID", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "newBatchId",
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newBatchId).value = $event)),
                class: "w-full p-2 border border-gray-300 rounded-md mt-1",
                placeholder: "Enter new Batch ID"
              }, null, 512), [
                [_vModelText, newBatchId.value]
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("button", {
                onClick: closeBatchIdModal,
                class: "bg-gray-200 text-gray-800 px-4 py-2 rounded-md"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: saveBatchId,
                class: "bg-primary text-white px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed",
                disabled: !newBatchId.value || newBatchId.value === _unref(importData)?.batchId
              }, " Save Changes ", 8, _hoisted_58)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (showWeightModal.value)
      ? (_openBlock(), _createBlock(ModalBox, {
          key: 3,
          onClose: closeWeightModal,
          width: "md"
        }, {
          header: _withCtx(() => _cache[25] || (_cache[25] = [
            _createElementVNode("h3", { class: "text-lg font-medium text-gray-900" }, " Edit Weight ", -1)
          ])),
          main: _withCtx(() => [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("p", _hoisted_60, [
                _cache[26] || (_cache[26] = _createTextVNode(" Current Weight: ")),
                _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(importData)?.size), 1)
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("label", {
                for: "newWeight",
                class: "block text-sm font-medium text-gray-700"
              }, "New Weight", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "newWeight",
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newWeight).value = $event)),
                class: "w-full p-2 border border-gray-300 rounded-md mt-1",
                placeholder: "Enter new Weight"
              }, null, 512), [
                [_vModelText, newWeight.value]
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("button", {
                onClick: closeWeightModal,
                class: "bg-gray-200 text-gray-800 px-4 py-2 rounded-md"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: saveWeight,
                class: "bg-primary text-white px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed",
                disabled: !newWeight.value || newWeight.value === _unref(importData)?.size
              }, " Save Changes ", 8, _hoisted_63)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(JustificationModal)
  ]))
}
}

})